import React, {useState} from "react";
import {DialogTitle, FormControl, FormLabel, Modal, ModalClose, ModalDialog, Stack, Switch, Button} from "@mui/joy";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

const QuickReportGenerator = ({type, id, modalOpen, closeModal, leagueId}) => {
    const [showHeader, setShowHeader] = useState(false);
    const [print, setPrint] = useState(false);
    const [activeDate, setActiveDate] = useState(dayjs(Date.now()));
    const [startDate, setStartDate] = useState(dayjs(Date.now()));
    const [endDate, setEndDate] = useState(dayjs(Date.now()));

    function handleReportGeneration() {
        let url = `/utils/league/reports/${type}/${leagueId}`;
        if (type === 'payoutsReport' && startDate && endDate) {
            url += `/${Math.floor(startDate.unix())}`;
            url += `/${Math.floor(endDate.unix())}`;
        } else if ((type === 'matchReport' || type === 'winnersReport' || type === 'blankScoreSheet') && id) {
            url += `/${id}`;
        } else if (type === 'matchSchedule' && startDate && endDate) {
            url += `/${Math.floor(startDate.unix())}`;
            url += `/${Math.floor(endDate.unix())}`;
        } else if (type === 'rosterReport' && activeDate) {
            url += `/${Math.floor(activeDate.unix())}`;
        } else if (type === 'handicapReport' && id) {
            url += `/${id}`;
        }

        if (print) url += '/true';
        if (!print) url += '/false';
        if (showHeader) url += '/true';
        if (!showHeader) url += '/false';
        window.open(url, '_blank');
    }

    return (
        <Modal open={modalOpen} onClose={closeModal}>
            <ModalDialog>
                <ModalClose/>
                <DialogTitle>Quick Report</DialogTitle>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    closeModal();
                }}>
                    <Stack spacing={2}>
                        {type === 'rosterReport' && (
                            <FormControl>
                                <FormLabel>Active Date</FormLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        value={activeDate}
                                        onChange={(newDate) => setActiveDate(newDate)}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        )}
                        {(type === 'matchSchedule' || type === 'payoutsReport') && (
                            <div>
                                <FormControl>
                                    <FormLabel>Start Date</FormLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            value={startDate}
                                            onChange={(newDate) => setStartDate(newDate)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                                <FormControl>
                                    <FormLabel>End Date</FormLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            value={endDate}
                                            onChange={(newDate) => setEndDate(newDate)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </div>
                        )}
                        <FormControl orientation={"horizontal"} sx={{width: 300, justifyContent: "space-between"}}>
                            <FormLabel>Print</FormLabel>
                            <Switch
                                checked={print}
                                onChange={(event) => setPrint(event.target.checked)}
                                color={print ? 'success' : 'neutral'}
                                variant={print ? 'solid' : 'outlined'}
                                endDecorator={print ? 'On' : 'Off'}
                                slotProps={{
                                    endDecorator: {
                                        sx: {
                                            minWidth: 24,
                                        },
                                    },
                                }}
                            />
                        </FormControl>
                        <FormControl orientation={"horizontal"} sx={{width: 300, justifyContent: "space-between"}}>
                            <FormLabel>Show Header</FormLabel>
                            <Switch
                                checked={showHeader}
                                onChange={(event) => setShowHeader(event.target.checked)}
                                color={showHeader ? 'success' : 'neutral'}
                                variant={showHeader ? 'solid' : 'outlined'}
                                endDecorator={showHeader ? 'On' : 'Off'}
                                slotProps={{
                                    endDecorator: {
                                        sx: {
                                            minWidth: 24,
                                        },
                                    },
                                }}
                            />
                        </FormControl>
                        <Button onClick={() => handleReportGeneration()}>Generate Report</Button>
                    </Stack>
                </form>
            </ModalDialog>
        </Modal>
    );
}

export default QuickReportGenerator;